export default __webpack_public_path__ + "static/media/asmrvideodb-privacy-policy.2a01c67b.pdf";